import React from "react";
import { Link } from "react-router-dom";
import AnimatedStats from "./AnimatedStats";
import "./contact.css";

const heroItems = [
  {
    icon: "ph-fill ph-phone-call",
    title: "Quick Response",
    text: "We aim to respond within minutes",
  },
  {
    icon: "ph-fill ph-headset",
    title: "Customer Support",
    text: "Our support team is available round the clock",
  },
  {
    icon: "ph-fill ph-shield-check",
    title: "Trusted & Reliable",
    text: "Your satisfaction is our top priority",
  },
];

const contactCards = [
  {
    image: "https://rghtnow.com/wp-content/uploads/2026/05/email.svg",
    title: "Email Us",
    text: "admin@rghtnow.com",
    href: "mailto:admin@rghtnow.com",
  },
  {
    image: "https://rghtnow.com/wp-content/uploads/2026/05/location-1.svg",
    title: "Head Office",
    text: "UAE",
  },
  {
    image: "https://rghtnow.com/wp-content/uploads/2026/05/location-2.svg",
    title: "Head Office",
    text: "India",
  },
];

const helpCards = [
  {
    image: "https://rghtnow.com/wp-content/uploads/2026/05/General-Inquiries.svg",
    title: "General Inquiries",
    text: "Questions about our platform and services",
  },
  {
    image: "https://rghtnow.com/wp-content/uploads/2026/05/Become-a-Merchant.svg",
    title: "Become a Merchant",
    text: "Grow your business with RGHT NOW",
  },
  {
    image: "https://rghtnow.com/wp-content/uploads/2026/05/Customer-Support.svg",
    title: "Customer Support",
    text: "Help with orders, refunds and account issues",
  },
  {
    image: "https://rghtnow.com/wp-content/uploads/2026/05/Delivery-Drivers.svg",
    title: "Delivery & Drivers",
    text: "Partner with us as a driver or delivery partner",
  },
  {
    image: "https://rghtnow.com/wp-content/uploads/2026/05/Advertising.svg",
    title: "Advertising",
    text: "Promote your brand with us",
  },
  {
    image: "https://rghtnow.com/wp-content/uploads/2026/05/Partnerships.svg",
    title: "Partnerships",
    text: "Business collaboration and partnerships",
  },
];

const ContactForm = () => {
  const handleSubmit = (event) => {
    event.preventDefault();
  };

  return (
    <form className="rghtnow-contact-form" onSubmit={handleSubmit}>
      <h2>Send Us a Message</h2>

      <div className="rghtnow-contact-form__grid">
        <label>
          <span>Your Name</span>
          <input type="text" placeholder="Enter Your Name" />
        </label>
        <label>
          <span>Your Email</span>
          <input type="email" placeholder="Enter Your Email" />
        </label>
        <label>
          <span>Mobile / WhatsApp number</span>
          <input type="tel" placeholder="Enter Mobile / WhatsApp number" />
        </label>
        <label>
          <span>Enter Subject</span>
          <input type="text" placeholder="Enter Subject" />
        </label>
        <label className="rghtnow-contact-form__full">
          <span>Textarea</span>
          <textarea rows="6" placeholder="How can we help you?" />
        </label>
      </div>

      <label className="rghtnow-contact-policy">
        <input type="checkbox" />
        <span>I agree to the Privacy Policy and Terms & Conditions</span>
      </label>

      <button type="submit" className="rghtnow-contact-submit">
        <span>Send Message</span>
      </button>
    </form>
  );
};

const Contact = () => {
  return (
    <main className="rghtnow-contact">
      <section className="rghtnow-contact-hero">
        <div className="container container-lg">
          <div className="rghtnow-contact-hero__grid">
            <div className="rghtnow-contact-hero__content">
              <span className="rghtnow-contact-eyebrow">Contact Us</span>
              <h1>
                We're Here to Help You, <span>Anytime!</span>
              </h1>
              <p>
                Have questions or need support? Get in touch with our team and
                we'll get back to you as soon as possible.
              </p>

              <span className="rghtnow-contact-hero__plane">
                <i className="ph-fill ph-paper-plane-tilt" />
              </span>

              <div className="rghtnow-contact-hero__features">
                {heroItems.map((item) => (
                  <div className="rghtnow-contact-feature" key={item.title}>
                    <span className="rghtnow-contact-feature__icon">
                      <i className={item.icon} />
                    </span>
                    <div>
                      <h3>{item.title}</h3>
                      <p>{item.text}</p>
                    </div>
                  </div>
                ))}
              </div>
            </div>

            <ContactForm />
          </div>
        </div>
      </section>

      <AnimatedStats subtitle="Connect with our team as RGHT NOW expands customer, merchant, and delivery coverage across UAE and India." />

      <section className="rghtnow-contact-info">
        <div className="container container-lg">
          <div className="rghtnow-contact-cards">
            {contactCards.map((item) => {
              const content = (
                <>
                  <span className="rghtnow-contact-card__icon">
                    <img src={item.image} alt="" />
                  </span>
                  <h3>{item.title}</h3>
                  <p>{item.text}</p>
                </>
              );

              return item.href ? (
                <a className="rghtnow-contact-card" href={item.href} key={item.title}>
                  {content}
                </a>
              ) : (
                <div className="rghtnow-contact-card" key={`${item.title}-${item.text}`}>
                  {content}
                </div>
              );
            })}
          </div>
        </div>
      </section>

      <section className="rghtnow-contact-map">
        <iframe
          title="RGHT NOW locations map"
          src="https://www.google.com/maps?q=Dubai%20UAE%20Bhopal%20India&output=embed"
          loading="lazy"
          referrerPolicy="no-referrer-when-downgrade"
        />
        <div className="container container-lg">
          <div className="rghtnow-contact-map__card">
            <h2>Find Us</h2>
            <strong>RGHT NOW Marketplace</strong>
            <p>Dubai, UAE</p>
            <p>Bhopal, India</p>
            <a href="#contact-help">
              <span>Get Directions</span>
              <i className="ph ph-arrow-right" />
            </a>
          </div>
        </div>
      </section>

      <section className="rghtnow-contact-help" id="contact-help">
        <div className="container container-lg">
          <div className="rghtnow-contact-section-head">
            <h2>
              How Can We <span>Help</span> You?
            </h2>
            <p>Choose from a wide range of services tailored for your everyday needs.</p>
          </div>

          <div className="rghtnow-contact-help__grid">
            {helpCards.map((item) => (
              <div className="rghtnow-contact-help-card" key={item.title}>
                <span className="rghtnow-contact-help-card__icon">
                  <img src={item.image} alt="" />
                </span>
                <h3>{item.title}</h3>
                <p>{item.text}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      <section className="rghtnow-contact-chat">
        <div className="container container-lg">
          <div className="rghtnow-contact-chat__inner">
            <div className="rghtnow-contact-chat__image">
              <img
                src="https://rghtnow.com/wp-content/uploads/2026/05/shop-rghtnow.svg"
                alt="Shop RGHT NOW"
              />
            </div>
            <div className="rghtnow-contact-chat__content">
              <h2>Need Immediate Assistance?</h2>
              <p>Chat with our support team now for instant help.</p>
            </div>
            <Link className="rghtnow-contact-chat__button" to="/contact-us">
              <span>Chat Now</span>
              <i className="ph-fill ph-whatsapp-logo" />
            </Link>
          </div>
        </div>
      </section>
    </main>
  );
};

export default Contact;
